(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.paragraph_link_blocks = {
    attach: function (context, settings) {

      $(once('slick', '.paragraph--type--hero:not(.paragraph--view-mode--content_aside) .links-blocks .items')).each(function (e) {
        $(this).slick({
          arrows: false,
          dots: false,
          slidesToShow: $(this).attr('data-items-shown'),
          swipe: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                dots: true,
                swipe: true,
              },
            },
          ],
        }).on('setPosition', function (event, slick) {
          document.documentElement.style.setProperty('--p-hero--lblocks--height', ($('.paragraph--hero .links-blocks').outerHeight() + 'px'));
        });
      });

      // Create media query if max width 959 px then run matchheight. Check on resize we check again
      const mediaQuery = window.matchMedia('(max-width: 959px)');

      function handleTabletChange(e) {
        if (e.matches) {
          // If media query matches
          $(once('matchheight-remove', '.paragraph--type--hero:not(.paragraph--view-mode--content_aside) .links-blocks .items .link-block')).matchHeight('remove');
        } else {
          // If media query does not match
          $(once('matchheight', '.paragraph--type--hero:not(.paragraph--view-mode--content_aside) .links-blocks .items .link-block')).matchHeight();
        }
      }

      // Initial check
      handleTabletChange(mediaQuery);
      // Listen for state changes
      mediaQuery.addListener(handleTabletChange);
    },
  };
})(jQuery, Drupal);